var BACKGROUND_PARAM = 'bc';
var IMAGE_BACKGROUND_PARAM = 'ib';
var HEIGHT_PARAM = 'h';
var QUALITY_PARAM = 'q';
var WIDTH_PARAM = 'w';

function getBackgroundColorForVariants(url, backgroundColor) {
  if (typeof backgroundColor === 'undefined') {
    return url.searchParams.get(IMAGE_BACKGROUND_PARAM);
  }

  return backgroundColor;
}

function sanitizeUrlFromWrongParams(url) {
  url.searchParams.delete(HEIGHT_PARAM);
  url.searchParams.delete(QUALITY_PARAM);
  url.searchParams.delete(WIDTH_PARAM);
  url.searchParams.delete(BACKGROUND_PARAM);
  url.searchParams.delete(IMAGE_BACKGROUND_PARAM);
}

function createVariant(variant, baseUrl, backgroundColor) {
  var variantURL = new URL(baseUrl.toString());
  variantURL.searchParams.set(WIDTH_PARAM, variant.width.toString());

  if (typeof backgroundColor === 'string') {
    variantURL.searchParams.set(BACKGROUND_PARAM, backgroundColor);
    variantURL.searchParams.set(IMAGE_BACKGROUND_PARAM, backgroundColor);
  }

  if (variant.height !== undefined) {
    variantURL.searchParams.set(HEIGHT_PARAM, variant.height.toString());
  }

  if (variant.quality !== undefined) {
    variantURL.searchParams.set(QUALITY_PARAM, variant.quality.toString());
  }

  return {
    width: variant.width,
    url: variantURL.toString()
  };
}
/**
 * Function generates srcSets basing on passed array of Images.
 * @param image
 * @returns srcSet string
 */


export var generateSrcSet = function generateSrcSet(image) {
  return image.map(function (variant) {
    return variant.url + " " + variant.width + "w";
  }).join(',');
};
/**
 * Function provides images urls base on the needs of the developer.
 * It allows to customize width, height and quality for each variant
 * and one background color for all variants.
 * @param entryData
 * @returns ImageVariant[]
 */

export function getImageVariants(entryData) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO
  if (entryData === null || typeof entryData.url === 'undefined') {
    throw new Error('You must provide a base url');
  }

  var baseUrl = new URL(entryData.url);
  var backgroundColor = getBackgroundColorForVariants(baseUrl, entryData.backgroundColor);
  sanitizeUrlFromWrongParams(baseUrl);
  var variants = Object.values(entryData.params).filter(function (variant) {
    return Boolean(variant.width);
  }).map(function (variant) {
    return createVariant(variant, baseUrl, backgroundColor);
  });
  return variants;
}